module.exports = __webpack_public_path__ + "static/media/grace.97a4697d.jpg";